<mat-form-field appearance="outline" class="w-p-100">
  <mat-chip-listbox #chipList aria-label="Contact selection">
    <mat-chip
      *ngFor="let contact of contacts"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(contact)">
      {{contact.firstName + ' ' + contact.lastName}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      placeholder="To..."
      #contactInput
      [formControl]="contactCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)">
  </mat-chip-listbox>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let contact of filteredContacts | async" [value]="contact">
      {{contact.email}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<!--    TODO: Don't remove the following line. Need to update it with ckeditor5-->
<!--<ckeditor-->
<!--  [(ngModel)]="ckeditorContent"-->
<!--  [config]="ckeConfig"-->
<!--  [readonly]="false"-->
<!--  (change)="onChange($event)"-->
<!--  (editorChange)="onEditorChange($event)"-->
<!--  (ready)="onReady($event)"-->
<!--  (focus)="onFocus($event)"-->
<!--  (blur)="onBlur($event)"-->
<!--  (contentDom)="onContentDom($event)"-->
<!--  (fileUploadRequest)="onFileUploadRequest($event)"-->
<!--  (fileUploadResponse)="onFileUploadResponse($event)"-->
<!--  (paste)="onPaste($event)"-->
<!--  (drop)="onDrop($event)"-->
<!--  debounce="500">-->
<!--</ckeditor>-->
<!--<div *ngIf="replyMessageModel && replyMessageModel.fileAttachments.length>0">-->
<!--<div *ngFor="let attachment of replyMessageModel.fileAttachments" fxLayout="column">-->
<!--<div  fxLayout="row" fxLayoutAlign="space-between center" class="attachment-container">-->
<!--<a (click)="downloadAttachment(attachment)" class="link-color">{{attachment.attachmentTitle}}</a>-->
<!--<button mat-icon-button class="">-->
<!--<i (click)="deleteAttachment(attachment)" class="fal fa-times"></i>-->
<!--</button>-->
<!--</div>-->

<!--</div>-->
<!--</div>-->
<div class="reply-mail-footer-toolbar flex flex-row justify-between items-center">
  <div class="flex flex-row justify-start items-center">
    <button (click)="reply()" mat-button class="action-button" type="button">
      Send
    </button>
    <!--<button  mat-icon-button fxLayout="row" fxLayoutAlign="center center" class="mail-footer-toolbar-button m-l-5"-->
    <!--(click)="showFileDialog()">-->
    <!--<i class="fal fa-paperclip"></i>-->
    <!--</button>-->
    <!--</div>-->
    <!--<div fxLayout="row" fxLayoutAlign="start center">-->
    <!--<button mat-icon-button class="mail-footer-toolbar-button" fxLayout="row" fxLayoutAlign="center center">-->
    <!--<i (click)="discard()" class="fal fa-trash"></i>-->
    <!--</button>-->
    <!--</div>-->

  </div>


